// import React, {
//   useContext,
//   useEffect,
//   useState,
//   useRef,
//   useCallback,
// } from "react";
// import { FaSearch } from "react-icons/fa";
// import { useNavigate, useParams } from "react-router-dom";
// import GigsCart from "../../../../../components/Dashboard/GigsCart";
// import AlertContext from "../../../../../Context/Alert/AlertContext";
// import { BaseURL } from "../../../../../Files/BaseURL";
// import ThemeContext from "../../../../../Context/theme/ThemeContext";

// const ServiceList = () => {
//   const { theme } = useContext(ThemeContext);
//   const { id } = useParams();
//   const [portfolios, setPortfolios] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedLevel, setSelectedLevel] = useState("");
//   const [selectedSpeak, setSelectedSpeak] = useState("");
//   const [totalLives, setTotalLives] = useState("");
//   const [totalItems, setTotalItems] = useState(0);
//   const [page, setPage] = useState(1);
//   const [hasMore, setHasMore] = useState(true);
//   const [loading, setLoading] = useState(true);
//   const itemsPerPage = 30;

//   const navigate = useNavigate();
//   const observer = useRef();
//   const lastPortfolioElementRef = useCallback(
//     (node) => {
//       if (loading) return;
//       if (observer.current) observer.current.disconnect();
//       observer.current = new IntersectionObserver((entries) => {
//         if (entries[0].isIntersecting && hasMore) {
//           setPage((prevPage) => prevPage + 1);
//         }
//       });
//       if (node) observer.current.observe(node);
//     },
//     [loading, hasMore]
//   );

//   const alertContext = useContext(AlertContext);
//   const { showAlert } = alertContext;

//   const fetchServices = async () => {
//     try {
//       const authToken = localStorage.getItem("p@token");
//       const response = await fetch(
//         `${BaseURL}/api/marektplace/Service/listservice/${id}?page=${page}&limit=${itemsPerPage}`,
//         {
//           headers: {
//             "auth-token": authToken,
//           },
//         }
//       );

//       if (!response.ok) {
//         throw new Error("Network response was not ok");
//       }

//       const result = await response.json();

//       if (result.success) {
//         setPortfolios((prevPortfolios) => {
//           if (page === 1) {
//             return result.data;
//           }
//           return [...prevPortfolios, ...result.data];
//         });
//         setHasMore(result.pagination.hasMore);
//         setTotalItems(result.pagination.totalItems);
//       } else {
//         throw new Error(result.message || "Error fetching Services");
//       }
//     } catch (error) {
//       showAlert(error.message, "danger");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     setPortfolios([]);
//     setPage(1);
//     setHasMore(true);
//     setLoading(true);
//   }, [searchTerm, selectedLevel, selectedSpeak, totalLives]);

//   useEffect(() => {
//     if (id) {
//       fetchServices();
//     }
//   }, [id, page, searchTerm, selectedLevel, selectedSpeak, totalLives]);

//   const filteredPortfolios = portfolios.filter((item) => {
//     const matchesSearch =
//       !searchTerm ||
//       item.title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       item.description?.toLowerCase().includes(searchTerm.toLowerCase());

//     const matchesLevel = !selectedLevel || item.sellerLevel === selectedLevel;
//     const matchesSpeak = !selectedSpeak || item.sellerSpeak === selectedSpeak;
//     const matchesLives = !totalLives || item.sellerLives === totalLives;

//     return matchesSearch && matchesLevel && matchesSpeak && matchesLives;
//   });

//   return (
//     <div className="w-[95%] m-auto py-6">
//       <div className="flex flex-col gap-4 xl:flex-row justify-between font-pop xl:items-center">
//         <div className="flex gap-2 md:gap-6 items-center">
//           <h3
//             className={`text-lg md:text-2xl font-medium ${
//               theme === "dark" && "text-white"
//             }`}
//           >
//             App Design
//           </h3>
//         </div>
//         <div className="flex flex-col lg:flex-row lg:items-center gap-2">
//           <div className="flex flex-row flex-wrap gap-4 items-center">
//             <div
//               className={`rounded-2xl px-1 md:px-3 ${
//                 theme === "dark" ? "bg-black text-white" : "bg-white"
//               }`}
//             >
//               <select
//                 value={selectedLevel}
//                 onChange={(e) => setSelectedLevel(e.target.value)}
//                 className={`border-none outline-none focus:outline-none focus:border-none focus:outline-transparent active:border-none active:outline-none text-sm md:text-lg font-normal ${
//                   theme === "dark" ? "bg-black text-white" : "bg-white"
//                 }`}
//               >
//                 <option value="">Seller level</option>
//                 <option value="New Seller">New Seller</option>
//                 <option value="1st Level">1st Level</option>
//                 <option value="2nd Level">2nd Level</option>
//               </select>
//             </div>
//             <div
//               className={`rounded-2xl px-1 md:px-3 ${
//                 theme === "dark" ? "bg-black text-white" : "bg-white"
//               }`}
//             >
//               <select
//                 value={selectedSpeak}
//                 onChange={(e) => setSelectedSpeak(e.target.value)}
//                 className={`border-none outline-none focus:outline-none focus:border-none focus:outline-transparent active:border-none active:outline-none text-sm md:text-lg font-normal ${
//                   theme === "dark" ? "bg-black text-white" : "bg-white"
//                 }`}
//               >
//                 <option value="">Seller speaks</option>
//                 <option value="English">English</option>
//                 <option value="German">German</option>
//                 <option value="French">French</option>
//               </select>
//             </div>
//             <div
//               className={`rounded-2xl px-1 md:px-3 ${
//                 theme === "dark" ? "bg-black text-white" : "bg-white"
//               }`}
//             >
//               <select
//                 value={totalLives}
//                 onChange={(e) => setTotalLives(e.target.value)}
//                 className={`border-none outline-none focus:outline-none focus:border-none focus:outline-transparent active:border-none active:outline-none text-sm md:text-lg font-normal ${
//                   theme === "dark" ? "bg-black text-white" : "bg-white"
//                 }`}
//               >
//                 <option value="">Seller lives</option>
//                 <option value="Asia">Asia</option>
//                 <option value="Europe">Europe</option>
//                 <option value="USA">USA</option>
//               </select>
//             </div>
//           </div>
//           <div
//             className={`flex gap-3 items-center rounded-full py-1 px-4 ${
//               theme === "dark" ? "bg-black text-white" : "bg-white"
//             }`}
//           >
//             <FaSearch
//               className={`text-gray-400 text-lg md:text-2xl ${
//                 theme === "dark" && "text-white"
//               }`}
//             />
//             <input
//               type="text"
//               placeholder="Search..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               className="bg-transparent text-sm md:text-lg border-none outline-none focus:outline-none focus:border-none active:outline-none"
//             />
//           </div>
//         </div>
//       </div>
//       <p
//         className={`text-lightGrey font-pop my-4 ${
//           theme === "dark" && "text-white"
//         }`}
//       >
//         Total {totalItems} Results
//       </p>
//       <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-x-4 gap-y-6 my-6">
//         {loading && page === 1 ? (
//           <div className="col-span-full flex justify-center py-10">
//             <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primarygreen"></div>
//           </div>
//         ) : (
//           filteredPortfolios?.map((item, index) => {
//             if (filteredPortfolios?.length === index + 1) {
//               return (
//                 <div ref={lastPortfolioElementRef} key={item.id}>
//                   <GigsCart item={item} />
//                 </div>
//               );
//             } else {
//               return <GigsCart item={item} key={item.id} />;
//             }
//           })
//         )}
//       </div>

//       {loading && page > 1 && (
//         <div className="flex justify-center py-4">
//           <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-primarygreen"></div>
//         </div>
//       )}

//       {!hasMore && !loading && filteredPortfolios.length > 0 && (
//         <div className="text-center py-4 text-gray-500">
//           No more items to load
//         </div>
//       )}

//       {!loading && filteredPortfolios.length === 0 && (
//         <div className="text-center py-4 font-pop text-lg font-medium">
//           No Service Ad's Found
//         </div>
//       )}
//     </div>
//   );
// };

// export default ServiceList;






import React, { useContext, useEffect, useState, useRef, useCallback } from "react";
import { FaSearch } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import GigsCart from "../../../../../components/Dashboard/GigsCart";
import AlertContext from "../../../../../Context/Alert/AlertContext";
import { BaseURL } from "../../../../../Files/BaseURL";
import ThemeContext from "../../../../../Context/theme/ThemeContext";
import debounce from "lodash.debounce"; // Install lodash for debouncing

const ServiceList = () => {
  const { theme } = useContext(ThemeContext);
  const { id } = useParams();
  const [portfolios, setPortfolios] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedLevel, setSelectedLevel] = useState("");
  const [selectedSpeak, setSelectedSpeak] = useState("");
  const [totalLives, setTotalLives] = useState("");
  const [totalItems, setTotalItems] = useState(0);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);

  const itemsPerPage = 30;
  const navigate = useNavigate();
  const observer = useRef();
  const alertContext = useContext(AlertContext);
  const { showAlert } = alertContext;

  // Debounced search term to avoid excessive API calls
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm);

  // Debounce the search term update
  const debouncedSetSearchTerm = useCallback(
    debounce((value) => {
      setDebouncedSearchTerm(value);
      setPage(1); // Reset page when search term changes
    }, 500),
    []
  );

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    debouncedSetSearchTerm(e.target.value);
  };

  const fetchServices = async (reset = false) => {
    if (loading) return; // Prevent multiple fetches
    setLoading(true);
    try {
      const authToken = localStorage.getItem("p@token");
      // Build query string with filters
      const queryParams = new URLSearchParams({
        page,
        limit: itemsPerPage,
        ...(debouncedSearchTerm && { search: debouncedSearchTerm }),
        ...(selectedLevel && { sellerLevel: selectedLevel }),
        ...(selectedSpeak && { sellerSpeak: selectedSpeak }),
        ...(totalLives && { sellerLives: totalLives }),
      });

      const response = await fetch(
        `${BaseURL}/api/marektplace/Service/listservice/${id}?${queryParams.toString()}`,
        {
          headers: {
            "auth-token": authToken,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const result = await response.json();

      if (result.success) {
        setPortfolios((prevPortfolios) => {
          if (reset || page === 1) {
            return result.data;
          }
          return [...prevPortfolios, ...result.data];
        });
        setHasMore(result.pagination.hasMore);
        setTotalItems(result.pagination.totalItems);
      } else {
        throw new Error(result.message || "Error fetching Services");
      }
    } catch (error) {
      showAlert(error.message, "danger");
    } finally {
      setLoading(false);
    }
  };

  // IntersectionObserver for infinite scrolling
  const lastPortfolioElementRef = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPage((prevPage) => prevPage + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMore]
  );

  // Reset filters and fetch data when filters change
  useEffect(() => {
    setPortfolios([]);
    setPage(1);
    setHasMore(true);
    fetchServices(true);
  }, [id, debouncedSearchTerm, selectedLevel, selectedSpeak, totalLives]);

  // Fetch additional pages
  useEffect(() => {
    if (page > 1) {
      fetchServices();
    }
  }, [page]);

  // Client-side filtering (fallback if API doesn't support filtering)
  const filteredPortfolios = portfolios.filter((item) => {
    const matchesSearch =
      !debouncedSearchTerm ||
      (item.Title?.toLowerCase() || "").includes(debouncedSearchTerm.toLowerCase()) ||
      (item.Pacakage?.Description?.toLowerCase() || "").includes(debouncedSearchTerm.toLowerCase()) ||
      (item.Keywords || []).some((keyword) => keyword.toLowerCase().includes(debouncedSearchTerm.toLowerCase()));

    const matchesLevel = !selectedLevel || item.User?.Level === selectedLevel;
    const matchesSpeak = !selectedSpeak || item.User?.Languages?.includes(selectedSpeak);
    const matchesLives = !totalLives || item.User?.Homeaddress?.Country === totalLives;

    return matchesSearch && matchesLevel && matchesSpeak && matchesLives;
  });

  return (
    <div className="w-[95%] m-auto py-6">
      <div className="flex flex-col gap-4 xl:flex-row justify-between font-pop xl:items-center">
        <div className="flex gap-2 md:gap-6 items-center">
          <h3
            className={`text-lg md:text-2xl font-medium ${theme === "dark" && "text-white"
              }`}
          >
            App Design
          </h3>
        </div>
        <div className="flex flex-col lg:flex-row lg:items-center gap-2">
          <div className="flex flex-row flex-wrap gap-4 items-center">
            <div
              className={`rounded-2xl px-1 md:px-3 ${theme === "dark" ? "bg-black text-white" : "bg-white"
                }`}
            >
              <select
                value={selectedLevel}
                onChange={(e) => setSelectedLevel(e.target.value)}
                className={`border-none outline-none focus:outline-none text-sm md:text-lg font-normal ${theme === "dark" ? "bg-black text-white" : "bg-white"
                  }`}
              >
                <option value="">Seller level</option>
                <option value="New">New Seller</option>
                <option value="Level 1">1st Level</option>
                <option value="Level 2">2nd Level</option>
              </select>
            </div>
            <div
              className={`rounded-2xl px-1 md:px-3 ${theme === "dark" ? "bg-black text-white" : "bg-white"
                }`}
            >
              <select
                value={selectedSpeak}
                onChange={(e) => setSelectedSpeak(e.target.value)}
                className={`border-none outline-none focus:outline-none text-sm md:text-lg font-normal ${theme === "dark" ? "bg-black text-white" : "bg-white"
                  }`}
              >
                <option value="">Seller speaks</option>
                <option value="English">English</option>
                <option value="German">German</option>
                <option value="French">French</option>
              </select>
            </div>
            <div
              className={`rounded-2xl px-1 md:px-3 ${theme === "dark" ? "bg-black text-white" : "bg-white"
                }`}
            >
              <select
                value={totalLives}
                onChange={(e) => setTotalLives(e.target.value)}
                className={`border-none outline-none focus:outline-none text-sm md:text-lg font-normal ${theme === "dark" ? "bg-black text-white" : "bg-white"
                  }`}
              >
                <option value="">Seller Lives</option>
                <option value="United States">United States</option>
                <option value="Afghanistan">Afghanistan</option>
              </select>
            </div>
          </div>
          <div
            className={`flex gap-3 items-center rounded-full py-1 px-4 ${theme === "dark" ? "bg-black text-white" : "bg-white"
              }`}
          >
            <FaSearch
              className={`text-gray-400 text-lg md:text-2xl ${theme === "dark" && "text-white"
                }`}
            />
            <input
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={handleSearchChange}
              className="bg-transparent text-sm md:text-lg border-none outline-none focus:outline-none"
            />
          </div>
        </div>
      </div>
      <p
        className={`text-lightGrey font-pop my-4 ${theme === "dark" && "text-white"
          }`}
      >
        Total {totalItems} Results
      </p>
      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-x-4 gap-y-6 my-6">
        {loading && page === 1 ? (
          <div className="col-span-full flex justify-center py-10">
            <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primarygreen"></div>
          </div>
        ) : (
          filteredPortfolios?.map((item, index) => {
            if (filteredPortfolios?.length === index + 1) {
              return (
                <div ref={lastPortfolioElementRef} key={item.id}>
                  <GigsCart item={item} />
                </div>
              );
            } else {
              return <GigsCart item={item} key={item.id} />;
            }
          })
        )}
      </div>

      {loading && page > 1 && (
        <div className="flex justify-center py-4">
          <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-primarygreen"></div>
        </div>
      )}

      {!hasMore && !loading && filteredPortfolios.length > 0 && (
        <div className="text-center py-4 text-gray-500">
          No more items to load
        </div>
      )}

      {!loading && filteredPortfolios.length === 0 && (
        <div className="text-center py-4 font-pop text-lg font-medium">
          No Service Ads Found
        </div>
      )}
    </div>
  );
};

export default ServiceList;